import classNames from "classnames";
import styles from "./scrollable.module.css";

export const Scrollable = ({ children, className, ...props }) => {
    return (
        <div className={classNames(styles.scrollable, className)} {...props}>
            {children}
        </div>
    );
}